var exports = {
  "D": "x0a7806d5--23d8e6--title",
};

module.exports = exports;
